var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 13C26.2091 13 28 11.2091 28 9C28 6.79086 26.2091 5 24 5C21.7909 5 20 6.79086 20 9C20 11.2091 21.7909 13 24 13Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15C43.2091 15 45 13.2091 45 11C45 8.79086 43.2091 7 41 7C38.7909 7 37 8.79086 37 11C37 13.2091 38.7909 15 41 15Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26.5H17V23C17 19.134 20.134 16 24 16C27.866 16 31 19.134 31 23V26.5Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 18C38.791 18 37 19.791 37 22V29.981L31.621 31.038C30.698 31.215 30 32.025 30 33V41.5C30 42.328 30.672 43 31.5 43C32.328 43 32.921 42.31 33.019 41.5C33.056 41.193 33.81 35 33.81 35H41C43.209 35 45 33.209 45 31V22C45 19.791 43.209 18 41 18Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15C9.20914 15 11 13.2091 11 11C11 8.79086 9.20914 7 7 7C4.79086 7 3 8.79086 3 11C3 13.2091 4.79086 15 7 15Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18C9.209 18 11 19.791 11 22V29.981L16.379 31.038C17.302 31.215 18 32.025 18 33V41.5C18 42.328 17.328 43 16.5 43C15.672 43 15.079 42.31 14.981 41.5C14.944 41.193 14.19 35 14.19 35H7C4.791 35 3 33.209 3 31V22C3 19.791 4.791 18 7 18Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28H15C14.448 28 14 27.552 14 27V26C14 25.448 14.448 25 15 25H33C33.552 25 34 25.448 34 26V27C34 27.552 33.552 28 33 28Z",
    fill: "#33CCFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19.1835,
    y1: -1.8096,
    x2: 22.0392,
    y2: 16.5669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1685C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056BB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 39.045,
    y1: 7.135,
    x2: 42.844,
    y2: 14.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0782D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 15.5711,
    y1: 7.0624,
    x2: 18.4114,
    y2: 31.4329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1685C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056BB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 28.469,
    y1: -3.28,
    x2: 42.744,
    y2: 51.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0782D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 8.955,
    y1: 7.135,
    x2: 5.156,
    y2: 14.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0782D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 19.531,
    y1: -3.28,
    x2: 5.256,
    y2: 51.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0782D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.b26d61ccfb24c0cb681397a3eef80dcb.svg";
export { ForwardRef as ReactComponent };